import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';

export const TimeLineService = ($timeout, $filter, CommonCodeService) => {
    const timeline = function (ctrl) {
        const removeHiddenDataSource = function (dataSource) {
            _.remove(dataSource, (dataSource) => {
                for (let i = 0; i < ctrl.jobTitlesDATA.length; i++) {
                    if (dataSource[ctrl.jobTitlesDATA[i].valueField]) {
                        return false;
                    }
                }
                return true;
            });
        };

        ctrl.options = {
            palette: 'Harmony Light',
            dataSource: [],

            size: {
                height: 40,
                width: 70,
            },
            commonSeriesSettings: {
                type: 'area',
                argumentField: 'val',
                hoverMode: 'none',
                area: {
                    color: 'rgba(67, 98, 164, 0.25)',
                },
            },
            series: [
                {
                    valueField: 's',
                    border: {
                        visible: true,
                        color: '#4362A4'
                    }
                },
            ],

            argumentAxis: {
                categories: [],
                constantLineStyle: {
                    color: '#CE5C32',
                    width: 3,
                    label: {
                        visible: false,
                    },
                },
                label: {
                    visible: false,
                },
                constantLines: [
                    { value: '18' },
                ],
            },
            valueAxis: {
                label: {
                    visible: false,
                },
                grid: {
                    visible: false,
                },
            },
        };

        ctrl.createPositionGraph = function (positionId) {
            $timeout(() => {
                $(`#job-listing-area-chart-${positionId}`)
                    .attr('data-original-title', ctrl.initToolTipTitle(positionId));
                $(`[data-toggle="tooltip-${positionId}"]`)
                    .tooltip({});
            });
        };

        ctrl.createJobListingAreaChart = function (position) {
            const dataEntered = ctrl.getDataEnteredByPositionId(position.positionId);

            if (dataEntered != null) {
                const dataSource = [];
                const categories = [];
                let index = 1;
                let lastDayEntered = 0;
                let constantLine = null;
                if (dataEntered.newObj) {
                    dataSource.push({
                        val: index.toString(),
                        s: dataEntered.newObj
                    });
                    categories.push(index.toString());
                    lastDayEntered = dataEntered.newObj;
                    index++;
                }

                if (dataEntered.jobEntered) {
                    // for (var i = lastDayEntered ; i < dataEntered.jobEntered;i++){
                    //     dataSource.push({val: index.toString(), s: dataEntered.jobEntered});
                    //     index++;
                    // }
                    if (!constantLine && dataEntered.jobEntered > 18) {
                        categories.push(index.toString());
                        constantLine = index.toString();
                        index++;
                    }
                    dataSource.push({
                        val: index.toString(),
                        s: dataEntered.jobEntered
                    });
                    categories.push(index.toString());
                    lastDayEntered = dataEntered.jobEntered;
                    index++;
                }

                if (dataEntered.sendForFeedback) {
                    // for (var i = lastDayEntered ; i < dataEntered.sendForFeedback;i++){
                    //     dataSource.push({val: index.toString(), s: dataEntered.sendForFeedback});
                    //     index++;
                    // }
                    if (!constantLine && dataEntered.sendForFeedback > 18) {
                        categories.push(index.toString());
                        constantLine = index.toString();
                        index++;
                    }
                    dataSource.push({
                        val: index.toString(),
                        s: dataEntered.sendForFeedback
                    });
                    categories.push(index.toString());
                    lastDayEntered = dataEntered.sendForFeedback;
                    index++;
                }

                if (dataEntered.feedbackRecieved) {
                    // for (var i = lastDayEntered ; i < dataEntered.feedbackRecieved;i++){
                    //     dataSource.push({val: index.toString(), s: dataEntered.feedbackRecieved});
                    //     index++;
                    // }
                    if (!constantLine && dataEntered.feedbackRecieved > 18) {
                        categories.push(index.toString());
                        constantLine = index.toString();
                        index++;
                    }
                    dataSource.push({
                        val: index.toString(),
                        s: dataEntered.feedbackRecieved
                    });
                    categories.push(index.toString());
                    lastDayEntered = dataEntered.feedbackRecieved;
                    index++;
                }

                if (dataEntered.firstSubmission) {
                    // for (var i = lastDayEntered ; i < dataEntered.firstSubmission;i++){
                    //     dataSource.push({val: index.toString(), s: dataEntered.firstSubmission});
                    //     index++;
                    // }
                    if (!constantLine && dataEntered.firstSubmission > 18) {
                        categories.push(index.toString());
                        constantLine = index.toString();
                        index++;
                    }
                    dataSource.push({
                        val: index.toString(),
                        s: dataEntered.firstSubmission
                    });
                    categories.push(index.toString());
                    lastDayEntered = dataEntered.firstSubmission;
                    index++;
                }

                if (dataEntered.lastActionObject) {
                    // for (var i = lastDayEntered ; i < dataEntered.lastActionObject;i++){
                    //     dataSource.push({val: index.toString(), s: dataEntered.lastActionObject});
                    //     index++;
                    // }
                    if (!constantLine && dataEntered.lastActionObject > 18) {
                        categories.push(index.toString());
                        constantLine = index.toString();
                        index++;
                    }
                    dataSource.push({
                        val: index.toString(),
                        s: dataEntered.lastActionObject
                    });
                    categories.push(index.toString());
                    lastDayEntered = dataEntered.lastActionObject;
                    index++;
                }


                const options = angular.copy(ctrl.options);
                // options.argumentAxis.constantLines = [
                //     {value: ctrl.finishedTarget.target}
                // ];
                if (lastDayEntered > ctrl.finishedTarget.target) {
                    options.argumentAxis.constantLines = [
                        { value: ctrl.finishedTarget.target },
                    ];
                    options.commonSeriesSettings.argumentField = 's';
                }
                options.legend = {
                    visible: false,
                };
                if (constantLine) {
                    options.argumentAxis.constantLines[0].value = constantLine;
                } else {
                    categories.push(index.toString());
                    options.argumentAxis.constantLines[0].value = index.toString();
                }
                options.dataSource = dataSource;
                options.argumentAxis.categories = categories;
                position.options = options;
                // $("#job-listing-area-chart-" + id).dxChart(options).dxChart("instance");
            }
        };

        ctrl.toggleSelection = function (position) {
            // If the row is checked, we will add it to the job Titles DATA and rerender the job listing chart
            if (position && position.checked) {
                if (ctrl.jobTitlesDATA.length == 1) {
                    ctrl.jobTitlesDATA.unshift({
                        valueField: 'avg',
                        name: 'Average',
                        color: '#F7BF55',
                        dashStyle: 'dot',
                        hoverStyle: { dashStyle: 'dot' },
                    });
                }
                ctrl.jobTitlesDATA.unshift({
                    valueField: position.positionId, // replacing any whitespace ( trim all white spaces )
                    name: position.jobTitle,
                    color: CommonCodeService.generateRandomColor(), // random generate hexadecimal color
                    positionId: position.positionId,
                });
                ctrl.blnShowJobProgression = true;
            } else if (position) {
                const positionIdx = _.findIndex(ctrl.jobTitlesDATA, { valueField: position.positionId });
                if (positionIdx >= 0) {
                    // we will remove the position from the area and rerender the CHART
                    ctrl.jobTitlesDATA.splice(positionIdx, 1);
                    if (ctrl.jobTitlesDATA.length == 2) {
                        ctrl.jobTitlesDATA.splice(0, 1);
                    }
                }
            }

            ctrl.jobListingLineChartResponseOptions.series = angular.copy(ctrl.jobTitlesDATA);
            let garphTimeLineDays = 0;
            angular.forEach(ctrl.jobListingLineChartResponseOptions.dataSource, (data) => {
                const foundIndex = _.findIndex(ctrl.jobListingLineChartResponseOptions.series, (series) => {
                    if (data[series.valueField]) {
                        return true;
                    }
                    return false;
                });
                if (foundIndex >= 0 && data.dayIndex > garphTimeLineDays) {
                    garphTimeLineDays = data.dayIndex;
                }
            });
            ctrl.jobListingLineChartResponseOptions.series.unshift({
                valueField: 'show',
                name: ' ',
                color: 'transparent',
                dashStyle: 'dot',
                hoverStyle: { dashStyle: 'dot' },
            });
            const newOptions = angular.copy(ctrl.jobListingLineChartResponseOptions);
            for (let i = 0; i < garphTimeLineDays; i++) {
                newOptions.dataSource.push({
                    day: (i + 1),
                    dayIndex: (i + 1),
                    statusIndex: 0,
                    show: $filter('translate')('NEW_JOB_TIMELINE'),
                });
            }
            newOptions.dataSource = _.sortBy(newOptions.dataSource, ['dayIndex', 'statusIndex']);

            if (ctrl.jobTitlesDATA.length > 1) {
                // we will calculate the average value of all the datasource
                ctrl.calculateAverageJobTimeLineChart(newOptions);
                if (ctrl.blnShowJobProgression) {
                    removeHiddenDataSource(newOptions.dataSource);
                    $('#job-listing-line-chart')
                        .dxChart(newOptions);
                }
            } else if (ctrl.blnShowJobProgression) {
                removeHiddenDataSource(newOptions.dataSource);
                $('#job-listing-line-chart')
                    .dxChart(newOptions);
            }
        };


        ctrl.calculateAverageJobTimeLineChart = function (options) {
            const customDataSourceData = [];

            // loop over the series and get the names of we need
            angular.forEach(ctrl.jobListingLineChartResponseOptions.series, (series) => {
                if (series.positionId) {
                    const positionIndex = _.findIndex(ctrl.dataEnteredByPositionId, { positionId: series.positionId });
                    if (positionIndex >= 0) {
                        customDataSourceData.push(ctrl.dataEnteredByPositionId[positionIndex]);
                    }
                }
            });

            const row = [
                {
                    name: $filter('translate')('NEW_JOB_TIMELINE'),
                    sum: 0,
                    count: 0,
                    statusIndex: 1,
                },
                {
                    name: $filter('translate')('JOB_ENTERED_TIMELINE'),
                    sum: 0,
                    count: 0,
                    statusIndex: 2,
                },
                {
                    name: $filter('translate')('SEND_FOR_FEEDBACK_TIMELINE'),
                    sum: 0,
                    count: 0,
                    statusIndex: 3,
                },
                {
                    name: $filter('translate')('FEEDBACK_RECEIVED_TIMELINE'),
                    sum: 0,
                    count: 0,
                    statusIndex: 4,
                },
                {
                    name: $filter('translate')('FIRST_SUBMISSION_TIMELINE'),
                    sum: 0,
                    count: 0,
                    statusIndex: 5,
                },
                {
                    name: $filter('translate')('ABANDONED_TIMELINE'),
                    sum: 0,
                    count: 0,
                    statusIndex: 6,
                },
            ];

            // loop over data source and check every step which day
            angular.forEach(customDataSourceData, (rowData) => {
                if (rowData.newObj) {
                    row[0].sum += rowData.newObj;
                    row[0].count++;
                }
                if (rowData.jobEntered) {
                    row[1].sum += rowData.jobEntered;
                    row[1].count++;
                }
                if (rowData.sendForFeedback) {
                    row[2].sum += rowData.sendForFeedback;
                    row[2].count++;
                }
                if (rowData.feedbackRecieved) {
                    row[3].sum += rowData.feedbackRecieved;
                    row[3].count++;
                }
                if (rowData.firstSubmission) {
                    row[4].sum += rowData.firstSubmission;
                    row[4].count++;
                }
                if (rowData.lastActionObject) {
                    row[5].sum += rowData.lastActionObject;
                    row[5].count++;
                }
            });

            // var dSource = angular.copy(ctrl.originalDataSource);

            angular.forEach(row, (day) => {
                if (day.count != 0) {
                    const dayCount = Math.round(day.sum / day.count);
                    // just push
                    options.dataSource.push({
                        day: dayCount,
                        dayIndex: dayCount,
                        statusIndex: day.statusIndex,
                        avg: day.name,
                    });
                }
            });

            // new , jobEntered  , sendForFeedback , feedbackRecieved, firstSubmission, lastActionObject
            // New,  Active      , requstFeedback , feedbackAccepted , Sent , Cancelled

            // add it to count.
            // JobListingLineChart.setJobListingData(dSource);

            options.dataSource = _.sortBy(options.dataSource, ['dayIndex', 'statusIndex']);
            // redraw
        };


        ctrl.getDataEnteredByPositionId = function (id) {
            const obj = _.find(ctrl.dataEnteredByPositionId, { positionId: id });
            if (obj) {
                return obj;
            }
            return null;
        };

        ctrl.initToolTipTitle = function (positionId) {
            const dataEntered = ctrl.getDataEnteredByPositionId(positionId);
            const newValue = '';

            if (dataEntered) {
                return ctrl.setToolTipTitle(dataEntered);
            }

            return newValue;
        };

        ctrl.setToolTipTitle = function (dataEntered) {
            const newText = $filter('translate')('NEW_JOB_TIMELINE');
            const jobEnteredText = $filter('translate')('JOB_ENTERED_TIMELINE');
            const sendForFeedbackText = $filter('translate')('SEND_FOR_FEEDBACK_TIMELINE');
            const feedbackReceivedText = $filter('translate')('FEEDBACK_RECEIVED_TIMELINE');
            const firstSubmissionText = $filter('translate')('FIRST_SUBMISSION_TIMELINE');
            const abandonedText = $filter('translate')('ABANDONED_TIMELINE');

            return `<div><h3>${dataEntered.jobTitle}</h3>`
                + `<ul><li>${newText}:</li>`
                + `<li>${jobEnteredText}: </li>`
                + `<li>${sendForFeedbackText}: </li>`
                + `<li>${feedbackReceivedText}: </li>`
                + `<li>${firstSubmissionText}: </li>`
                + `<li>${abandonedText}: </li> </ul><ul class='s-chart-v'>`
                + `<li>${dataEntered.newObj ? `${dataEntered.newObj} days` : '-'}</li>`
                + `<li>${dataEntered.jobEntered ? `${dataEntered.jobEntered} days` : '-'}</li>`
                + `<li>${dataEntered.sendForFeedback ? `${dataEntered.sendForFeedback} days` : '-'}</li>`
                + `<li>${dataEntered.feedbackRecieved ? `${dataEntered.feedbackRecieved} days` : '-'}</li>`
                + `<li>${dataEntered.firstSubmission ? `${dataEntered.firstSubmission} days` : '-'}</li>`
                + `<li>${dataEntered.lastActionObject ? `${dataEntered.lastActionObject} days` : '-'}</li></ul></div>`;
        };

        ctrl.reCreateAreaChart = function (positionsKey) {
            ctrl[positionsKey] = _.map(ctrl[positionsKey], (position) => {
                position.options = null;
                return position;
            });
            $timeout(() => {
                angular.forEach(ctrl[positionsKey], (position) => {
                    // $("#job-listing-area-chart-" + position.positionId).attr('data-original-title', ctrl.initToolTipTitle(position.positionId));
                    ctrl.createJobListingAreaChart(position);
                });
            }, 300);
        };

        ctrl.checkIfShowProgressFlase = function () {
            if (!ctrl.blnShowJobProgression) {
                return;
            }
            ctrl.toggleSelection();
        };

        // for the series label
        const expected = {
            valueField: 'exp',
            name: 'Expected',
            color: '#B57D1D',
            dashStyle: 'dot',
            hoverStyle: { dashStyle: 'dot' },
        };

        // Adding average and expected to the job Titles DATA
        // TODO: Need to calculate the average data
        // TODO: Waiting for the expected to the BB of talenya dev.

        ctrl.jobTitlesDATA = [];
        ctrl.jobTitlesDATA.push(expected);
    };

    return {
        timeline,
    };
};

angular.module('TALENYA-FE')
    .factory('TimeLineService', TimeLineService);
